import { GlModal, GlForm, GlFormCheckbox, GlSprintf, GlFormGroup } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import api from '../../../api.js?vue3';
import { BV_SHOW_MODAL } from '~/lib/utils/constants';
import csrf from '~/lib/utils/csrf';
import eventHub from '../event_hub';
import BranchesDropdown from './branches_dropdown.vue?vue3';
import ProjectsDropdown from './projects_dropdown.vue?vue3';
export default {
    name: 'FormModal',
    components: {
        BranchesDropdown,
        ProjectsDropdown,
        GlModal,
        GlForm,
        GlFormCheckbox,
        GlSprintf,
        GlFormGroup
    },
    inject: {
        modalStore: {},
        prependedText: {
            default: ''
        }
    },
    props: {
        i18n: {
            type: Object,
            required: true
        },
        openModal: {
            type: String,
            required: true
        },
        modalId: {
            type: String,
            required: true
        },
        isCherryPick: {
            type: Boolean,
            required: false,
            default: false
        },
        primaryActionEventName: {
            type: String,
            required: false,
            default: null
        }
    },
    data () {
        return {
            checked: true,
            copyDescription: false,
            actionPrimary: {
                text: this.i18n.actionPrimaryText,
                attributes: {
                    variant: 'confirm',
                    category: 'primary',
                    'data-testid': 'submit-commit'
                }
            },
            actionCancel: {
                text: this.i18n.actionCancelText,
                attributes: {
                    'data-testid': 'cancel-commit'
                }
            }
        };
    },
    mounted () {
        eventHub.$on(this.openModal, this.show);
    },
    methods: {
        setBranch (branch) {
            this.modalStore.setBranch(branch);
        },
        setSelectedProject (id) {
            this.modalStore.setSelectedProject(id);
        },
        show () {
            this.$root.$emit(BV_SHOW_MODAL, this.modalId);
        },
        handlePrimary () {
            if (this.primaryActionEventName) {
                api.trackRedisHllUserEvent(this.primaryActionEventName);
            }
            this.$refs.form.$el.submit();
        },
        resetModalHandler () {
            this.modalStore.clearModal();
            this.checked = true;
            this.copyDescription = false;
        }
    },
    csrf
};
